/* !
 * jQuery enjoy v1.0.0
 * Copyright 2021, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';

	// ＜enjoy詳細＞関連記事取得
	const getJSONrelatedArticles = (_tagArr, _thisNewsID) => {
		let jsonPath = (FUNCTIONS.va.region === 'jp') ? '/ajax/enjoy/related_news.json?' : `/global/${FUNCTIONS.va.region}/ajax/enjoy/related_news.json?`;
		for (let i = 0; i < _tagArr.length; i++) {
			jsonPath += `tag=${_tagArr[i]}&`;
		}
		jsonPath += `exclude_id=${_thisNewsID}`;
		return $.getJSON(jsonPath);
	};
	const setRelatedArticles = () => {
		if (FUNCTIONS.va.pathname.indexOf('/enjoy/detail/') !== -1) {
			let tagArr = [];
			$('.rt_cf_n_tags_disp').find('li').each((idx, ele) => {
				tagArr.push($(ele).find('a').attr('data-key'));
			});
			getJSONrelatedArticles(tagArr, $('.rt_cf_n_key').attr('data-key')).then((data) => {
				if (data.rt_bn_news_list.length) {
					let relatedList = '';
					let articlePath = (FUNCTIONS.va.region === 'jp') ? '/enjoy/' : `/global/${FUNCTIONS.va.region}/enjoy/`;
					for (let i = 0; i < data.rt_bn_news_list.length; i++) {
						relatedList += `<li class="pure-u-1-3 pure-u-md-1-2 space-u-40-child">`+
							`<a href="${articlePath}detail/${data.rt_bn_news_list[i]._key}.html" class="__boxLink">`;

						//［日］日付
						if (FUNCTIONS.va.region === 'jp') {
							relatedList += `<span class="__date"><time>${data.rt_bn_news_list[i].rt_cf_n_date.content}</time></span>`;
						}
						// サムネイル画像
						if (data.rt_bn_news_list[i].rt_cf_n_thum_img) {
							relatedList += `<figure><img src="${data.rt_bn_news_list[i].rt_cf_n_thum_img.src}" `+
								`alt="${data.rt_bn_news_list[i].rt_cf_n_thum_img.alt}" class="width-u-100">`;
						} else {
							relatedList += `<figure><img src="/images/dummy/news_small.jpg" alt="" class="width-u-100">`; // サムネイルなし デフォルト画像？
						}
						relatedList += '<figcaption class="__txt" data-mh="enjoy-txt">';
						//［グローバル］日付
						if (FUNCTIONS.va.region !== 'jp') {
							relatedList += `<time class="__date">${data.rt_bn_news_list[i].rt_cf_n_date.content}</time>`;
						}
						// タイトル
						relatedList += `<h4>${data.rt_bn_news_list[i].cf_n_title}</h4>`+
							`<p>${data.rt_bn_news_list[i].cf_n_sub_title}</p></figcaption></figure></a>`;

						// タグ
						if (data.rt_bn_news_list[i].cf_n_tags.length) {
							relatedList += '<ul class="__tags">';
							let tagsArr = data.rt_bn_news_list[i].cf_n_tags;
							for (let j = 0; j < tagsArr.length; j++) {
								let tagLabel;
								switch (FUNCTIONS.va.region) {
									case 'jp': tagLabel = tagsArr[j].cf_nt_name_d_jp; break;
									case 'cn': tagLabel = tagsArr[j].cf_nt_name_d_cn; break;
									case 'eu': tagLabel = tagsArr[j].cf_nt_name_d_eu; break;
									case 'us': tagLabel = tagsArr[j].cf_nt_name_d_us; break;
									default: break;
								}
								relatedList += `<li><a href="${articlePath}${tagsArr[j].cf_nt_url}/">#${tagLabel}</a></li>`;
							}
							relatedList += '</ul>';
						}
						relatedList += '</li>';
					}
					$('.js-relatedList-wrap').find('ul').append(relatedList);

				} else {
					$('.js-relatedList-wrap').remove();
				}
			});

		}
	};

	// ========= ↑↑ FUNCTIONS ↑↑ ========================================================================== //

	setRelatedArticles();


})(window.jQuery, window.FUNCTIONS);
